import errorSlice from './error-slice';

export const { reducer: errorReducer } = errorSlice;
